<!-- <svg width="225" height="315"> -->
<svg viewBox="0 0 225 315">
    <svg:defs>
        <svg:polygon id="d" class="diamond" points="28.5,0 48.612,29 28.5,58 8.388,29" />
        <svg:path
            id="h"
            class="heart"
            d="M16.491,0.199
            c7.12-0.475,10.831,5.639,11.556,10.456c0.432,0.766,0.668,0.55,0.834-0.042c0.348-6.186,5.855-11.24,10.955-10.55
            c8.3,0.108,13.344,9.393,11.926,17.251c-1.733,9.6-6.877,15.38-10.771,21.332C36.585,44.811,30.654,53.715,28.742,58
            c0,0-6.027-9.222-13.87-20.067c-5.243-7.252-9.44-15.11-9.831-21.875C4.595,8.327,7.751,1.399,16.491,0.199L16.491,0.199z"
        />
        <svg:path
            id="s"
            class="spade"
            d="M26.406,40.187c0.015-1.979-1.561-2.017-1.542-0.573c-0.133,7.257-6.311,10.83-10.799,9.982
            c-6.92-1.307-9.129-8.129-9.062-12.148C5.205,25.046,17.775,15.9,29.116,0c8.311,14.351,22.028,25.623,22.839,36.717
            c1.08,14.749-17.711,20.25-20.394,3.06c-0.173-1.214-1.613-1.759-1.501-0.063c0.408,4.711-0.171,6.674,5.179,18.287H21.252
            C24.351,52.574,26.195,45.911,26.406,40.187L26.406,40.187z"
        />
        <svg:path
            id="c"
            class="club"
            d="M20.976,57.141c2.879-5.775,4.976-11.7,5.348-18.037c0.342-2.331-1.074-2.37-1.288-0.729
            c-4.076,15.593-25.763,11.37-25.017-3.296c0.604-11.896,12.42-14.454,18.582-10.565c2.434,1.434,2.295,0.575,0.967-0.911
            C10.416,13.391,15.958,0.241,28.331,0c13.38,0.793,16.853,14.87,8.646,23.147c-1.021,0.994-3.283,4.191,0.123,1.956
            c8.287-5.888,19.787,0.443,19.553,9.521c-0.434,16.738-20.84,17.986-25.203,4.006c-0.42-1.55-1.629-2.328-1.295,0.305
            c0.604,4.767,1.855,11.953,5.438,18.205L20.976,57.141L20.976,57.141z"
        />

        <svg:path
            id="A"
            class="ace"
            d="M21.2,27.63H8.16L5.52,35.6H0L12.5,0h4.36l12.5,35.6h-5.49L21.2,27.63z M19.71,22.85L14.74,7.28h-0.09L9.67,22.85H19.71z"
        />
        <svg:path
            id="2"
            class="two"
            d="M0,31.17l13.45-17.42c0.52-0.7,0.87-1.35,1.06-1.96c0.13-0.57,0.19-1.11,0.19-1.61c0-1.34-0.4-2.5-1.21-3.5
		c-0.84-1-2.02-1.51-3.55-1.54c-1.36,0-2.48,0.45-3.38,1.35c-0.93,0.9-1.48,2.16-1.66,3.79H0c0.13-2.96,1.09-5.4,2.88-7.34
		C4.69,1.06,6.92,0.1,9.56,0.07c2.96,0.03,5.36,1.01,7.2,2.93c1.87,1.91,2.82,4.33,2.86,7.26c0,2.35-0.69,4.43-2.08,6.26L6.47,30.88
		h13.14v5.08H0V31.17z"
        />
        <svg:path
            id="3"
            class="three"
            d="M7.83,15.38h1.7c1.69,0,2.99-0.48,3.92-1.45c0.93-0.93,1.39-2.14,1.39-3.63c-0.03-1.51-0.51-2.74-1.44-3.71
		c-0.93-0.93-2.12-1.42-3.59-1.45c-1.05,0-2.01,0.35-2.88,1.06C6.02,6.9,5.41,7.99,5.09,9.46H0.16C0.41,6.83,1.44,4.6,3.25,2.8
		c1.78-1.79,3.9-2.7,6.37-2.73c3.13,0.03,5.61,1.07,7.45,3.1c1.76,1.99,2.66,4.33,2.69,7.03c0,1.37-0.24,2.69-0.73,3.96
		c-0.57,1.27-1.58,2.4-3.04,3.39c1.49,0.98,2.57,2.15,3.24,3.52c0.63,1.37,0.95,2.8,0.95,4.3c-0.03,3.34-1.03,5.97-2.99,7.89
		c-1.93,1.97-4.42,2.97-7.45,3c-2.34,0-4.42-0.78-6.22-2.34C1.7,32.35,0.53,30.09,0,27.13h4.93c0.44,1.19,1.06,2.15,1.86,2.89
		c0.82,0.77,1.9,1.15,3.26,1.15c1.45,0,2.67-0.51,3.66-1.54c1.01-0.96,1.52-2.33,1.56-4.11c-0.03-1.81-0.55-3.21-1.56-4.21
		c-0.99-0.96-2.25-1.44-3.77-1.44h-2.1V15.38z"
        />
        <svg:path
            id="4"
            class="four"
            d="M0,25.52L11.49,0h5.48L5.36,25.52h8.98V15.26h4.91v10.25h2.76v4.78h-2.76v5.3h-4.91v-5.3L0,30.3V25.52z"
        />
        <svg:path
            id="5"
            class="five"
            d="M0.6,0h18.33v5.08H5.23v8.11c1.61-1.3,3.45-1.95,5.51-1.95c1.32,0.03,2.54,0.28,3.64,0.73c1.04,0.5,1.88,1.12,2.53,1.85
		c0.96,0.98,1.65,2.11,2.07,3.39c0.22,0.7,0.38,1.55,0.47,2.56c0.09,1.02,0.14,2.29,0.14,3.78c0,2.31-0.16,4.08-0.47,5.32
		c-0.33,1.22-0.88,2.3-1.65,3.25c-0.68,0.92-1.66,1.76-2.95,2.53c-1.26,0.79-2.75,1.21-4.48,1.24c-2.33,0-4.46-0.71-6.39-2.14
		c-1.97-1.46-3.19-3.83-3.66-7.09h4.94c0.54,2.74,2.18,4.13,4.94,4.16c1.18,0,2.12-0.24,2.83-0.73c0.68-0.47,1.15-1.09,1.42-1.86
		c0.28-0.77,0.46-1.6,0.52-2.5c0.03-0.88,0.05-1.74,0.05-2.57c0.03-2.04-0.28-3.69-0.92-4.97c-0.35-0.6-0.86-1.08-1.54-1.44
		c-0.68-0.29-1.52-0.44-2.53-0.44c-0.9,0-1.72,0.21-2.46,0.64c-0.74,0.44-1.41,1.21-1.99,2.3H0.6V0z"
        />
        <svg:path
            id="6"
            class="six"
            d="M16.69-0.01c0.02,0-0.06,0.18-0.23,0.52c-0.17,0.35-0.4,0.83-0.69,1.43c-0.29,0.6-0.63,1.29-1.02,2.08
		c-0.39,0.78-0.8,1.6-1.23,2.47c-0.43,0.86-0.87,1.73-1.31,2.61c-0.45,0.88-0.88,1.72-1.29,2.51c-0.41,0.8-0.79,1.52-1.13,2.17
		c-0.34,0.65-0.62,1.17-0.85,1.56c0.47-0.28,1-0.44,1.59-0.5c0.59-0.06,1.28-0.07,2.06-0.04c1.12,0.03,2.1,0.23,2.93,0.59
		c0.84,0.36,1.55,0.81,2.15,1.34c0.6,0.54,1.1,1.14,1.5,1.79c0.4,0.66,0.71,1.3,0.94,1.93c0.23,0.63,0.39,1.21,0.48,1.76
		c0.09,0.55,0.13,0.97,0.13,1.28c0,0.1,0,0.28,0,0.54c0,0.26,0,0.55,0,0.87s0,0.64-0.01,0.96c-0.01,0.33-0.02,0.6-0.04,0.83
		c-0.02,0.11-0.07,0.41-0.16,0.89c-0.09,0.48-0.25,1.05-0.49,1.71c-0.24,0.66-0.57,1.37-1.01,2.12c-0.44,0.76-1.01,1.47-1.73,2.15
		c-0.71,0.68-1.58,1.26-2.6,1.75s-2.24,0.79-3.65,0.9c-1.48,0.13-2.78,0.03-3.92-0.29c-1.14-0.33-2.12-0.79-2.95-1.39
		c-0.83-0.6-1.52-1.3-2.07-2.09c-0.55-0.79-0.99-1.6-1.3-2.43s-0.53-1.63-0.63-2.39c-0.11-0.76-0.13-1.42-0.06-1.95
		c0.1-0.8,0.2-1.51,0.32-2.14c0.11-0.63,0.25-1.22,0.4-1.79c0.15-0.57,0.33-1.13,0.52-1.68c0.19-0.55,0.42-1.16,0.68-1.81
		c0.06-0.16,0.24-0.55,0.54-1.16s0.65-1.36,1.08-2.26c0.43-0.9,0.91-1.88,1.45-2.95s1.07-2.16,1.61-3.27
		c1.27-2.57,2.69-5.44,4.26-8.62H16.69z M15.67,26.04c0-0.62-0.02-1.3-0.07-2.05c-0.05-0.75-0.23-1.46-0.55-2.14
		c-0.32-0.68-0.83-1.26-1.55-1.75c-0.71-0.49-1.73-0.78-3.04-0.88c-0.62-0.05-1.18,0.02-1.68,0.2c-0.5,0.18-0.95,0.42-1.34,0.73
		c-0.39,0.31-0.73,0.66-1.01,1.06c-0.28,0.4-0.52,0.79-0.71,1.18s-0.32,0.75-0.4,1.09c-0.08,0.33-0.12,0.59-0.12,0.77
		c0,0.41,0.01,0.86,0.02,1.35c0.02,0.5,0.07,0.99,0.16,1.49c0.09,0.5,0.24,0.98,0.45,1.44c0.21,0.46,0.51,0.88,0.9,1.23
		c0.39,0.36,0.89,0.65,1.5,0.88C8.84,30.88,9.6,31,10.51,31c0.73,0.02,1.37-0.08,1.91-0.28c0.54-0.2,1.01-0.46,1.39-0.78
		c0.38-0.32,0.69-0.67,0.94-1.06c0.24-0.39,0.43-0.77,0.57-1.15c0.14-0.37,0.23-0.71,0.28-1.01C15.65,26.41,15.67,26.19,15.67,26.04
		z"
        />
        <svg:path id="7" class="seven" d="M0,0h19.55v5.08L7.91,35.6H2.42l11.6-30.52H4.91v5.16H0V0z" />
        <svg:path
            id="8"
            class="eight"
            d="M0,25.57c0.03-3.44,1.43-6.11,4.19-8.01c-1.06-0.93-1.88-1.99-2.48-3.2c-0.7-1.12-1.05-2.46-1.05-4.01
		c0.03-2.96,1-5.41,2.9-7.35c1.79-1.92,4.11-2.9,6.94-2.93C13.39,0.1,15.74,1.08,17.57,3c1.84,1.94,2.78,4.39,2.81,7.35
		c0,1.55-0.32,2.88-0.95,4c-0.67,1.2-1.53,2.27-2.58,3.2c2.76,1.9,4.16,4.57,4.19,8.01c-0.03,3.21-1.05,5.77-3.05,7.69
		c-2.04,1.97-4.53,2.97-7.48,3c-2.93-0.03-5.39-1.03-7.36-3C1.08,31.33,0.03,28.77,0,25.57z M4.92,25.52
		c0.03,1.63,0.6,2.97,1.71,4.01c1.06,1.09,2.35,1.64,3.88,1.64c1.57,0,2.89-0.55,3.95-1.64c1.08-1.04,1.63-2.38,1.66-4.01
		c-0.03-1.66-0.59-3.02-1.66-4.06c-1.06-1.03-2.38-1.56-3.95-1.59c-1.52,0.03-2.81,0.56-3.88,1.59C5.52,22.5,4.95,23.85,4.92,25.52z
		 M5.58,10.25c0.03,1.65,0.55,2.91,1.54,3.78c0.98,0.9,2.11,1.35,3.39,1.35c1.33,0,2.48-0.45,3.46-1.35
		c0.96-0.87,1.46-2.13,1.49-3.78c-0.03-1.7-0.53-2.99-1.49-3.85c-0.98-0.83-2.13-1.25-3.46-1.25c-1.28,0-2.41,0.42-3.39,1.25
		C6.12,7.26,5.61,8.55,5.58,10.25z"
        />
        <svg:path
            id="9"
            class="nine"
            d="M3.92,35.8c-0.02,0,0.12-0.3,0.41-0.89c0.29-0.59,0.67-1.36,1.14-2.31c0.47-0.94,1-1.99,1.58-3.15
		c0.58-1.16,1.16-2.29,1.73-3.42c0.57-1.12,1.1-2.16,1.59-3.1c0.5-0.94,0.9-1.68,1.21-2.22c-0.47,0.28-1,0.44-1.59,0.5
		c-0.59,0.06-1.28,0.07-2.06,0.04c-1.07-0.03-2.01-0.23-2.81-0.59c-0.8-0.36-1.5-0.81-2.08-1.34c-0.58-0.54-1.07-1.14-1.46-1.79
		s-0.7-1.3-0.94-1.93c-0.24-0.63-0.41-1.21-0.51-1.76c-0.11-0.54-0.16-0.97-0.16-1.28c0-0.1,0-0.28-0.01-0.54
		c-0.01-0.26-0.01-0.55-0.01-0.87s0-0.64,0.01-0.96C-0.02,9.86,0,9.59,0.03,9.36c0.02-0.11,0.07-0.4,0.16-0.87s0.26-1.02,0.5-1.67
		c0.24-0.65,0.58-1.35,1.02-2.09C2.15,3.99,2.72,3.3,3.43,2.65C4.13,1.99,5,1.43,6.03,0.96c1.03-0.47,2.25-0.77,3.66-0.9
		c1.48-0.13,2.78-0.04,3.91,0.27c1.13,0.31,2.1,0.76,2.91,1.34c0.81,0.59,1.48,1.27,2.02,2.05s0.95,1.57,1.25,2.38
		s0.5,1.59,0.6,2.34c0.1,0.76,0.11,1.4,0.05,1.94c-0.1,0.8-0.2,1.51-0.32,2.14c-0.11,0.63-0.25,1.23-0.4,1.79
		c-0.15,0.57-0.33,1.13-0.52,1.68c-0.19,0.55-0.42,1.16-0.68,1.81c-0.06,0.18-0.24,0.57-0.52,1.17c-0.28,0.6-0.64,1.34-1.07,2.21
		c-0.43,0.87-0.9,1.84-1.41,2.91c-0.51,1.07-1.03,2.14-1.57,3.21c-1.25,2.54-2.65,5.37-4.19,8.5H3.92z M5.02,10.02
		c0,0.63,0.03,1.33,0.1,2.1c0.06,0.77,0.26,1.49,0.57,2.16c0.32,0.68,0.82,1.25,1.5,1.73c0.68,0.48,1.64,0.75,2.87,0.82
		c0.62,0.03,1.18-0.04,1.68-0.23c0.5-0.19,0.95-0.44,1.34-0.74c0.39-0.31,0.73-0.66,1.01-1.05c0.28-0.39,0.52-0.78,0.71-1.16
		c0.19-0.38,0.32-0.74,0.4-1.06c0.08-0.33,0.12-0.59,0.12-0.78c-0.02-0.41-0.03-0.86-0.04-1.37c-0.01-0.5-0.06-1.02-0.15-1.54
		c-0.09-0.52-0.24-1.02-0.45-1.5c-0.21-0.48-0.51-0.9-0.9-1.26c-0.39-0.36-0.89-0.64-1.5-0.84c-0.61-0.2-1.37-0.28-2.28-0.23
		C9,5.11,8.18,5.36,7.54,5.82C6.9,6.28,6.39,6.78,6.02,7.33C5.64,7.89,5.38,8.42,5.24,8.94C5.09,9.47,5.02,9.82,5.02,10.02z"
        />
        <!-- <svg:path
            id="T"
            class="ten"
            d="M0,31.505V0H3.11v31.505H0L0,31.505z M12.328,0c-2.994,0-5.4,2.687-5.4,6.021v19.461c0,3.336,2.406,6.021,5.4,6.021h1.746c2.994,0,5.406-2.686,5.406-6.021V6.022C19.481,2.686,17.069,0,14.074,0H12.328z M13.232,2.978c1.768,0,3.19,1.337,3.19,3.002v19.723c0,1.664-1.424,3.006-3.19,3.006c-1.771,0-3.191-1.342-3.191-3.006V5.98C10.039,4.315,11.461,2.978,13.232,2.978z"
        /> -->
        <svg:g id="T" class="ten">
            <path d="M4.92,5.74L0.03,9.45V4.02l4.89-3.66h4.91v35.6H4.92V5.74z" />
            <path
                d="M12.83,10.28C12.86,7,13.87,4.47,15.87,2.7c1.87-1.75,4.11-2.63,6.7-2.63c2.67,0,4.95,0.88,6.82,2.64
                c1.9,1.77,2.89,4.31,2.95,7.59v15.7c-0.06,3.27-1.05,5.79-2.95,7.57c-1.87,1.76-4.15,2.65-6.82,2.69c-2.6-0.03-4.83-0.93-6.7-2.68
                c-2-1.77-3.01-4.29-3.04-7.56V10.28z M27.44,10.6c-0.1-3.57-1.71-5.39-4.86-5.46c-3.16,0.07-4.77,1.88-4.84,5.46v15.12
                c0.06,3.6,1.68,5.42,4.84,5.46c3.14-0.03,4.76-1.85,4.86-5.46V10.6z"
            />
        </svg:g>
        <svg:path
            id="J"
            class="jack"
            d="M4.36,28.21c0.49,0.67,1.12,1.22,1.9,1.64c0.78,0.51,1.68,0.76,2.73,0.76c1.39,0.03,2.71-0.47,3.98-1.5
		c0.62-0.51,1.1-1.18,1.44-2.01c0.36-0.8,0.54-1.81,0.54-3.01V0h5.24v24.61c-0.06,3.59-1.2,6.37-3.41,8.33
		c-2.19,2.01-4.74,3.03-7.65,3.06C5.08,35.9,2.04,34.36,0,31.37L4.36,28.21z"
        />
        <svg:path
            id="Q"
            class="queen"
            d="M19.96,32.67c-2,1.96-4.67,2.98-8,3.04c-2.67-0.06-4.89-0.74-6.67-2.02c-1.81-1.24-3.13-2.66-3.95-4.29
		c-0.25-0.53-0.47-1.04-0.67-1.52c-0.19-0.5-0.34-1.12-0.46-1.88c-0.23-1.41-0.35-4.12-0.35-8.14c0-4.08,0.12-6.81,0.35-8.19
		c0.25-1.38,0.63-2.5,1.14-3.35c0.82-1.62,2.14-3.07,3.95-4.33c1.78-1.28,4.01-1.94,6.67-1.97c2.7,0.03,4.94,0.69,6.74,1.97
		c1.78,1.27,3.07,2.71,3.86,4.33c0.57,0.85,0.97,1.97,1.19,3.35c0.2,1.38,0.3,4.11,0.3,8.19c0,3.64-0.08,6.19-0.23,7.63
		c-0.2,1.44-0.53,2.57-1,3.37l4.48,3.68l-3.05,3.66L19.96,32.67z M11.42,25.62l3.05-3.64l3.96,3.26c0.33-1.19,0.49-3.64,0.49-7.36
		c0-3.46-0.12-5.81-0.35-7.07c-0.25-1.19-0.71-2.16-1.37-2.92c-0.51-0.72-1.2-1.33-2.05-1.81c-0.9-0.47-1.96-0.72-3.19-0.75
		C10.74,5.36,9.7,5.61,8.83,6.08c-0.89,0.48-1.6,1.09-2.14,1.81C6.02,8.64,5.58,9.61,5.36,10.8c-0.25,1.25-0.37,3.61-0.37,7.07
		c0,3.46,0.12,5.8,0.37,7.02c0.22,1.22,0.66,2.21,1.33,2.97c0.54,0.72,1.26,1.31,2.14,1.76c0.87,0.53,1.91,0.8,3.12,0.8
		c1.58,0,2.85-0.41,3.8-1.23L11.42,25.62z"
        />
        <svg:path
            id="K"
            class="king"
            d="M0,0h5.21v18.34h0.1L19.46,0h6.18L14.63,14.04L26.8,35.6h-6.18l-9.37-17.41l-6.04,6.57V35.6H0V0z"
        />
    </svg:defs>
    <!-- Little Card -->
    <!-- Big Card -->

    <!-- Top Numeral and Suit -->
    @if (rabbitCard) {
        <image
            href="../../../../assets/img/card/rabbit.webp" 
            x="20" 
            y="200" 
            width="100" 
            height="100"
        >
        </image>
    }
    @if (rabbitCardBack) {
        <image
            href="../../../../assets/img/card/rabbit.webp"
            x="15" 
            y="100" 
            width="200" 
            height="200"
        >
        </image>
    }
    <svg:use
        x="-1"
        y="1"
        class="numeral"
        [ngClass]="{
            club: cardId[1] === 'c',
            heart: cardId[1] === 'h',
            diamond: cardId[1] === 'd',
            spade: cardId[1] === 's'
        }"
        transform="matrix(3.8,0,0,3.2,15,10)"
        attr.xlink:href="#{{ cardId[0] }}"
    />
    <svg:use
        x="90"
        y="165"
        class="numeral-down"
        [ngClass]="{
            club: cardId[1] === 'c',
            heart: cardId[1] === 'h',
            diamond: cardId[1] === 'd',
            spade: cardId[1] === 's'
        }"
        transform="matrix(1.8,0,0,1.5,0,0)"
        attr.xlink:href="#{{ cardId[0] }}"
    />
    <svg:use
        x="120"
        y="10"
        class="suit-up"
        [ngClass]="{
            club: cardId[1] === 'c',
            heart: cardId[1] === 'h',
            diamond: cardId[1] === 'd',
            spade: cardId[1] === 's'
        }"
        transform="matrix(1.25,0,0,1.25,0,0) "
        attr.xlink:href="#{{ cardId[1] }}"
    />
    <!-- Face Suit -->
    @if (!rabbitCard) {
        <svg:use
            x="0"
            y="78"
            class="suit-down"
            [ngClass]="{
                club: cardId[1] === 'c',
                heart: cardId[1] === 'h',
                diamond: cardId[1] === 'd',
                spade: cardId[1] === 's'
            }"
            transform="matrix(2.5,0,0,2.2,0,0) "
            attr.xlink:href="#{{ cardId[1] }}"
        />
    }
</svg>
